export const getRandomIndex = (arr: any, excludeIndex: number) => {
  let indexes = Object.keys(arr) //get a list of indexes
  indexes.splice(excludeIndex, 1) //remove the unwanted
  return Number(indexes[Math.floor(Math.random() * indexes.length)]) //pick a new index
}
